import getters from './get'
import actions from './action'
import mutations from './mutation'

const state = {
  service: {
    load: false
  }
}

export default {
  namepsaced: true,

  state,

  actions,
  getters,
  mutations
}
